import { FInter, FlexBox, GridBox, Colors, DropdownListItem, Skeleton } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";
import { VOTE_BLOCK_POSITION } from "../../sections/ps-bottom";
import { RectangularButtonFilled } from "shared/components/buttons";
import { BCoreLoaderWrapper } from "shared/icons/Progress";


export const DropdownText = styled(FInter.SmallTextBoldMagic)<{ isActive?: boolean }>`
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: ${p => p?.isActive ? Colors.galBlack100 : '#545453'};
`;

export const VoteWrapper = styled(FlexBox)<{ isMobile?: boolean, fullSize?: boolean, position: VOTE_BLOCK_POSITION }>`
  background-color: #f2f2f2;
  padding: 24px;
  border-radius: 8px;
  width: ${({ position }) => [VOTE_BLOCK_POSITION.longread, VOTE_BLOCK_POSITION.bottom].includes(position) ? '100%' : 'calc(100% - 24px)'};
  ${p => p.fullSize? 'margin: 24px 0' : 'margin: 17px 0'};
  // {p => p.fullSize && 'margin-bottom: 24px'};

  ${({ fullSize }) => fullSize && css`

    .dropdown-button {
      svg path {
        fill: #909090 !important;
      }
    }

    .dropdown-header, .icon-with-text {
      color: #909090 !important;

      &:hover {
        color: #909090 !important;
      }
    }

    ${DropdownListItem} {
      justify-content: flex-start;


      div {
        margin-right: 16px;
      }

      .active {
        color: #151514;
      }

      // svg {
      //   position: absolute;
      //   top: 50%;
      //   right: 0
      // }

      // * {
      //   color: #909090 !important;
      // }

      &:hover {
        * {
          color: #909090 !important;
        }
      }
    }

    .dropdown-list-item {
      &:first-child {
        color: #909090 !important;
      }
    }

  `};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: ${({ fullSize }) => fullSize ? '100%' : 'calc(100% - 24px)'};
    ${({ fullSize }) => fullSize && css`
      margin-left: 0;
      padding: 24px 24px 32px 24px;
    `};
    padding: 24px;

    .dropdown-header, .icon-with-text {
      font-size: 15px;
      line-height: 20px;
    }
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    width: ${({ fullSize }) => fullSize ? '100%' : 'auto'};
    padding: ${({ fullSize }) => fullSize ? '24px 24px 32px 24px' : '12px'};
    margin-left: ${({ fullSize }) => fullSize ? '0' : '16px'};
    margin-bottom: 24px;
  }
  @media (max-width: 780px) {
    width: ${({ fullSize }) => fullSize ? '100%' : '280px'}
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-left: 0;
    padding: ${({ fullSize }) => fullSize ? '16px' : '12px'};
    width: 100%;

    .icon-with-text {
      font-size: 13px;
      line-height: 16px;
    }

    .dropdown-shadow {
      display: none;
    }
  }
`;

export const SkelectonCard = styled(Skeleton)`
  height: 38px;
  min-height: 38px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    height: 24px;
    min-height: 24px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    height: 32px;
    min-height: 32px;
  }
`;

export const Container = styled.div<{ isMobile?: boolean, checked?: boolean, twoColumns?: boolean, fullSize?: boolean, width?: string, height?: string, isLoading?: boolean }>`
  position: relative;
    // width: ${({
    twoColumns,
    fullSize
  }) => twoColumns && !fullSize ? '38px' : fullSize ? '43.8px' : !twoColumns && fullSize ? 'auto' : '41px'};
  width: ${({ width }) => `${width}px`};
    // width: ${p => p?.isMobile ? '29px' : p?.twoColumns && !p?.fullSize ? '38px' : p?.fullSize ? '43.8px' : '41px'};
    // height: ${({ twoColumns, fullSize }) => twoColumns && !fullSize ? '28px' : fullSize ? '30px' : '32px'};
  height: ${({ height }) => `${height}px`};
  display: flex;
  border: 1px solid #909090;
  justify-content: center;
  cursor: pointer;
  background-color: transparent;
  border-radius: 6px;

  ${({ isLoading }) => isLoading && css`
    pointer-events: none;
  `};

  ${({ checked }) => checked && css`
    background-color: ${Colors.galBlack73};
    transition: background 0.2s;
  `};

  .vote-label {
    cursor: pointer;
  }

  .text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    color: ${({ checked }) => checked ? `${Colors.geoWhite100}` : `${Colors.galBlack73}`};
    transition: color 0.2s;
    cursor: pointer;
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark {
    cursor: pointer;
    position: absolute;
      // top: ${p => p?.isMobile ? '-28px' : '-24px'};
    top: 0;
    left: 0;
    min-height: ${p => p?.isMobile ? '20px' : '24px'};
    min-width: ${p => p?.isMobile ? '20px' : '24px'};
    background: #FEFEFE;
    border: 1px solid #B6B6B5;
    border-radius: 50%;
    z-index: 5;

    :before {
      content: '';
      width: 6px;
      height: 6px;
      background-color: black;
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      opacity: 0;
    }
  }


  :hover input ~ .checkmark {
    :before {
      opacity: 1;
    }
  }

  .vote-label {
    text-align: center;
  }

  input:checked ~ .checkmark {
    :before {
      opacity: 1;
    }
  }

  input:checked ~ .text {
    color: black;
  }

  .rectangle {
    background: transparent;
    border-radius: 10px;
    position: absolute;
    width: 24px;
    height: 62px;
    top: -34px;
    left: 0;
    z-index: 0;
    display: none;
  }

  &:hover {
    border-color: #545453;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
      // width: ${p => p?.fullSize ? '34.8px' : '29px'};
      // height: ${({ twoColumns, fullSize }) => fullSize ? '30px' : '24px'};
    width: 100%;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
      // width: ${p => p?.fullSize ? '47px' : '48.8px'};
  }
`;



export const VoteTitle = styled(FInter.SectionTitleSubtitleBoldFlex)<{ fullSize?: boolean }>`
  font-family: 'Inter';
  font-style: normal;
  font-size: 22px;
  line-height: 28px;
  font-weight: 700;
  color: ${Colors.galBlack73};
  margin-top: 8px;
  margin-bottom: 24px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${({ fullSize }) => fullSize && css`
      margin-bottom: 16px;
    `};
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 17px;
    line-height: 22px;
    font-weight: 700;
    letter-spacing: -0.02em;
    margin-top: 8px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 17px;
    line-height: 22px;
    font-weight: 700;
    letter-spacing: -0.02em;
    margin-top: 8px;
  }
`;
export const VoteButton = styled(RectangularButtonFilled)<{ hgt?: number, fullSize?: boolean, fakeDisabled?: boolean }>`
  font-size: 17px !important;
  line-height: 22px !important;
  letter-spacing: -0.02em !important;
  font-weight: 600 !important;
  margin-top: 24px;
  width: 100%;
  white-space: nowrap;
  min-width: 100%;
  max-width: 100%;
  height: ${({ hgt }) => `${hgt}px` || '32px'};
  min-height: ${({ hgt }) => `${hgt}px` || '32px'};

  ${BCoreLoaderWrapper} {
    width: 100%;
    padding: 0;
    margin: 0;

    svg {
      width: 26px;
      height: 26px;
      
      path {
        stroke: #545453;
      }
    }
  }

  svg {
    margin-left: 12px;
  }

  ${({ fakeDisabled }) => fakeDisabled && css`
    cursor: not-allowed;
    color: #B6B6B5;
    background: #E7E7E7;

    &:hover {
      cursor: not-allowed;
      color: #B6B6B5;
      background: #E7E7E7;
    }
  `};

  ${({ fullSize }) => fullSize && css`
    max-width: 415px;
    width: 415px;
    min-width: 415px;
    font-size: 17px !important;
    line-height: 22px !important;
  `};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${({ fullSize }) => fullSize && css`
      max-width: 283px;
      width: 283px;
      min-width: 283px;
      font-size: 15px !important;
      line-height: 20px !important;
    `};
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-top: 16px;
    height: 24px;
    min-height: 24px;
    font-size: 15px !important;
    line-height: 20px !important;

    ${({ fullSize }) => fullSize && css`
      max-width: calc(50% - 8px) !important;
      width: calc(50% - 8px) !important;
      min-width: calc(50% - 8px) !important;
      min-height: 32px !important;
    `};
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 17px !important;
    line-height: 22px !important;
    height: 32px;
    min-height: 32px;

    svg {
      margin-left: 6px;
    }

    ${({ fullSize }) => fullSize && css`
      max-width: 100%  !important;
      width: 100%  !important;
      min-width: 100%  !important;
      min-height: 32px;
      // margin-top: 24px
    `};
  }

`;

export const CriteryName = styled(FlexBox)<{ fullSize?: boolean, twoColumns?: boolean }>`
  font-family: 'Inter';
  font-style: normal;
  font-size: 17px;
  line-height: 22px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #545453;
  width: 170px;
  margin-right: 38px;

  ${({ fullSize }) => fullSize && css`
    width: 250px;
    margin-right: 8px;
    margin-bottom: 0;
  `};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: ${({ twoColumns }) => twoColumns ? '13px' : '15px'};
    line-height: ${({ twoColumns }) => twoColumns ? '16px' : '20px'};
    margin-right: 24px;
    width: 100px;
    font-weight: 600;

    ${({ fullSize }) => fullSize && css`
      width: 250px;
      margin-right: 8px;
      margin-bottom: 0;
    `};
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    width: 88px;
    margin-right: 12px;

    ${({ fullSize }) => fullSize && css`
      width: 200px;
      margin-right: 8px;
      margin-bottom: 0;
    `};
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    margin: 0 0 12px 0;

    ${({ fullSize }) => fullSize && css`
      font-size: 13px;
      line-height: 16px;
    `};
  }
`;


export const CriteryWrapper = styled(FlexBox)<{ twoColumns?: boolean, fullSize?: boolean, position: VOTE_BLOCK_POSITION }>`

  flex-direction: ${({ twoColumns, fullSize }) => twoColumns && !fullSize ? 'column' : 'row'};
  min-height: ${({
    twoColumns,
    fullSize,
    position
  }) => [VOTE_BLOCK_POSITION.longread, VOTE_BLOCK_POSITION.bottom].includes(position) ? (twoColumns ? '62px' : '80px') : (twoColumns ? '82px' : '56px')};
  // margin-top: 24px;

  ${({ fullSize }) => fullSize && css`
    margin-top: 16px;

    &:not(:first-child) {
      margin-top: 0;
    }

    &:not(:last-child) {
      border-bottom: 1px solid ${Colors.galBlack21};
    }
  `};

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-top: ${({ twoColumns, fullSize }) => fullSize ? '0px' : '12px'};
    height: ${({ twoColumns, fullSize }) => fullSize ? '54px' : '24px'};
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-direction: column;
    margin-top: ${({ twoColumns, fullSize }) => fullSize ? '0px' : '16px'};
    height: ${({ twoColumns, fullSize }) => fullSize ? '96px' : '60px'};

    &:not(:last-child) {
      margin-bottom: ${({ twoColumns, fullSize }) => fullSize ? '16px' : '0px'};
      border-bottom: none;
    }
  }
`

export const BlocksWrapper = styled(FlexBox)<{ iSBookMainPage?: boolean }>`
  width: 100%;
  flex-direction: column;
  row-gap: 24px;
  box-sizing: border-box;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    row-gap: 16px;
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    row-gap: 8px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    row-gap: 0px;
    width: ${({ iSBookMainPage }) => iSBookMainPage ? '100%' : 'calc(100% - 20px)'};
    margin: ${({ iSBookMainPage }) => iSBookMainPage ? '0 auto' : '0 10px'};
  }
`

export const MarkList = styled(GridBox)<{ twoColumns?: boolean, fullSize?: boolean, columnsGrid?: string, widthGrid?: string }>`
  grid-template-columns: ${({ columnsGrid, widthGrid }) => `repeat(${columnsGrid}, ${widthGrid}px)`};
  max-width: ${({ twoColumns, fullSize }) => twoColumns && !fullSize ? '455px' : fullSize ? 'none' : '247px'};
  width: 100%;
  justify-content: space-between;
  place-items: center;
    // ${({ fullSize }) => fullSize && css`
  //   place-items: center;
  `};

  @media (max-width: ${LayoutConst.screen.md}px) {
    max-width: none;
    grid-template-columns:  ${({ twoColumns }) => twoColumns ? 'repeat(10, 1fr);' : 'repeat(5, 1fr);'};
    gap: 12px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    max-width: ${({ fullSize }) => fullSize ? 'none' : '177px'};
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
      // width: ${({ fullSize }) => fullSize ? '268px' : '276px'};
      // grid-template-columns:  ${({ fullSize }) => fullSize ? 'repeat(5, 47.2px);' : 'repeat(5, 48.8px);'};
    grid-template-columns:  ${({ fullSize }) => fullSize ? 'repeat(5, 1fr);' : 'repeat(5, 1fr);'};
    gap: 8px;
    max-width: none;
  }
`

export const RectangleCount = styled.span<{ twoColumns?: boolean, fullSize?: boolean }>`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: ${({ twoColumns }) => twoColumns ? '15px' : '17px'};
  line-height: ${({ twoColumns }) => twoColumns ? '20px' : '22px'};
  color: #909090;
  top: 24px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: ${({ fullSize }) => fullSize ? '13px' : '17px'}
    line-height: ${({ fullSize }) => fullSize ? '16px' : '22px'}
  }
`;import { FInter, FlexBox, GridBox, Colors, DropdownListItem, Skeleton } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";
import { VOTE_BLOCK_POSITION } from "../../sections/ps-bottom";
import { RectangularButtonFilled } from "shared/components/buttons";
import { BCoreLoaderWrapper } from "shared/icons/Progress";


export const DropdownText = styled(FInter.SmallTextBoldMagic)<{ isActive?: boolean }>`
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: ${p => p?.isActive ? Colors.galBlack100 : '#545453'};
`;

export const VoteWrapper = styled(FlexBox)<{ isMobile?: boolean, fullSize?: boolean, position: VOTE_BLOCK_POSITION }>`
  background-color: #f2f2f2;
  padding: 24px;
  border-radius: 8px;
  width: ${({ position }) => [VOTE_BLOCK_POSITION.longread, VOTE_BLOCK_POSITION.bottom].includes(position) ? '100%' : 'calc(100% - 24px)'};
  ${p => p.fullSize? 'margin: 24px 0' : 'margin: 17px 0'};
  // {p => p.fullSize && 'margin-bottom: 24px'};

  ${({ fullSize }) => fullSize && css`

    .dropdown-button {
      svg path {
        fill: #909090 !important;
      }
    }

    .dropdown-header, .icon-with-text {
      color: #909090 !important;

      &:hover {
        color: #909090 !important;
      }
    }

    ${DropdownListItem} {
      justify-content: flex-start;


      div {
        margin-right: 16px;
      }

      .active {
        color: #151514;
      }

      // svg {
      //   position: absolute;
      //   top: 50%;
      //   right: 0
      // }

      // * {
      //   color: #909090 !important;
      // }

      &:hover {
        * {
          color: #909090 !important;
        }
      }
    }

    .dropdown-list-item {
      &:first-child {
        color: #909090 !important;
      }
    }

  `};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: ${({ fullSize }) => fullSize ? '100%' : 'calc(100% - 24px)'};
    ${({ fullSize }) => fullSize && css`
      margin-left: 0;
      padding: 24px 24px 32px 24px;
    `};
    padding: 24px;

    .dropdown-header, .icon-with-text {
      font-size: 15px;
      line-height: 20px;
    }
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    width: ${({ fullSize }) => fullSize ? '100%' : 'auto'};
    padding: ${({ fullSize }) => fullSize ? '24px 24px 32px 24px' : '12px'};
    margin-left: ${({ fullSize }) => fullSize ? '0' : '16px'};
    margin-bottom: 24px;
  }
  @media (max-width: 780px) {
    width: ${({ fullSize }) => fullSize ? '100%' : '280px'}
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    margin-left: 0;
    padding: ${({ fullSize }) => fullSize ? '16px' : '12px'};
    width: 100%;

    .icon-with-text {
      font-size: 13px;
      line-height: 16px;
    }

    .dropdown-shadow {
      display: none;
    }
  }
`;

export const SkelectonCard = styled(Skeleton)`
  height: 38px;
  min-height: 38px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    height: 24px;
    min-height: 24px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    height: 32px;
    min-height: 32px;
  }
`;

export const Container = styled.div<{ isMobile?: boolean, checked?: boolean, twoColumns?: boolean, fullSize?: boolean, width?: string, height?: string, isLoading?: boolean }>`
  position: relative;
    // width: ${({
    twoColumns,
    fullSize
  }) => twoColumns && !fullSize ? '38px' : fullSize ? '43.8px' : !twoColumns && fullSize ? 'auto' : '41px'};
  width: ${({ width }) => `${width}px`};
    // width: ${p => p?.isMobile ? '29px' : p?.twoColumns && !p?.fullSize ? '38px' : p?.fullSize ? '43.8px' : '41px'};
    // height: ${({ twoColumns, fullSize }) => twoColumns && !fullSize ? '28px' : fullSize ? '30px' : '32px'};
  height: ${({ height }) => `${height}px`};
  display: flex;
  border: 1px solid #909090;
  justify-content: center;
  cursor: pointer;
  background-color: transparent;
  border-radius: 6px;

  ${({ isLoading }) => isLoading && css`
    pointer-events: none;
  `};

  ${({ checked }) => checked && css`
    background-color: ${Colors.galBlack73};
    transition: background 0.2s;
  `};

  .vote-label {
    cursor: pointer;
  }

  .text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    color: ${({ checked }) => checked ? `${Colors.geoWhite100}` : `${Colors.galBlack73}`};
    transition: color 0.2s;
    cursor: pointer;
  }

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark {
    cursor: pointer;
    position: absolute;
      // top: ${p => p?.isMobile ? '-28px' : '-24px'};
    top: 0;
    left: 0;
    min-height: ${p => p?.isMobile ? '20px' : '24px'};
    min-width: ${p => p?.isMobile ? '20px' : '24px'};
    background: #FEFEFE;
    border: 1px solid #B6B6B5;
    border-radius: 50%;
    z-index: 5;

    :before {
      content: '';
      width: 6px;
      height: 6px;
      background-color: black;
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      opacity: 0;
    }
  }


  :hover input ~ .checkmark {
    :before {
      opacity: 1;
    }
  }

  .vote-label {
    text-align: center;
  }

  input:checked ~ .checkmark {
    :before {
      opacity: 1;
    }
  }

  input:checked ~ .text {
    color: black;
  }

  .rectangle {
    background: transparent;
    border-radius: 10px;
    position: absolute;
    width: 24px;
    height: 62px;
    top: -34px;
    left: 0;
    z-index: 0;
    display: none;
  }

  &:hover {
    border-color: #545453;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
      // width: ${p => p?.fullSize ? '34.8px' : '29px'};
      // height: ${({ twoColumns, fullSize }) => fullSize ? '30px' : '24px'};
    width: 100%;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
      // width: ${p => p?.fullSize ? '47px' : '48.8px'};
  }
`;



export const VoteTitle = styled(FInter.SectionTitleSubtitleBoldFlex)<{ fullSize?: boolean }>`
  font-family: 'Inter';
  font-style: normal;
  font-size: 22px;
  line-height: 28px;
  font-weight: 700;
  color: ${Colors.galBlack73};
  margin-top: 8px;
  margin-bottom: 24px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${({ fullSize }) => fullSize && css`
      margin-bottom: 16px;
    `};
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 17px;
    line-height: 22px;
    font-weight: 700;
    letter-spacing: -0.02em;
    margin-top: 8px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 17px;
    line-height: 22px;
    font-weight: 700;
    letter-spacing: -0.02em;
    margin-top: 8px;
  }
`;
export const VoteButton = styled(RectangularButtonFilled)<{ hgt?: number, fullSize?: boolean, fakeDisabled?: boolean }>`
  font-size: 17px !important;
  line-height: 22px !important;
  letter-spacing: -0.02em !important;
  font-weight: 600 !important;
  margin-top: 24px;
  width: 100%;
  white-space: nowrap;
  min-width: 100%;
  max-width: 100%;
  height: ${({ hgt }) => `${hgt}px` || '32px'};
  min-height: ${({ hgt }) => `${hgt}px` || '32px'};

  ${BCoreLoaderWrapper} {
    width: 100%;
    padding: 0;
    margin: 0;

    svg {
      width: 26px;
      height: 26px;
      
      path {
        stroke: #545453;
      }
    }
  }

  svg {
    margin-left: 12px;
  }

  ${({ fakeDisabled }) => fakeDisabled && css`
    cursor: not-allowed;
    color: #B6B6B5;
    background: #E7E7E7;

    &:hover {
      cursor: not-allowed;
      color: #B6B6B5;
      background: #E7E7E7;
    }
  `};

  ${({ fullSize }) => fullSize && css`
    max-width: 415px;
    width: 415px;
    min-width: 415px;
    font-size: 17px !important;
    line-height: 22px !important;
  `};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${({ fullSize }) => fullSize && css`
      max-width: 283px;
      width: 283px;
      min-width: 283px;
      font-size: 15px !important;
      line-height: 20px !important;
    `};
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-top: 16px;
    height: 24px;
    min-height: 24px;
    font-size: 15px !important;
    line-height: 20px !important;

    ${({ fullSize }) => fullSize && css`
      max-width: calc(50% - 8px) !important;
      width: calc(50% - 8px) !important;
      min-width: calc(50% - 8px) !important;
      min-height: 32px !important;
    `};
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 17px !important;
    line-height: 22px !important;
    height: 32px;
    min-height: 32px;

    svg {
      margin-left: 6px;
    }

    ${({ fullSize }) => fullSize && css`
      max-width: 100%  !important;
      width: 100%  !important;
      min-width: 100%  !important;
      min-height: 32px;
      // margin-top: 24px
    `};
  }

`;

export const CriteryName = styled(FlexBox)<{ fullSize?: boolean, twoColumns?: boolean }>`
  font-family: 'Inter';
  font-style: normal;
  font-size: 17px;
  line-height: 22px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #545453;
  width: 170px;
  margin-right: 38px;

  ${({ fullSize }) => fullSize && css`
    width: 250px;
    margin-right: 8px;
    margin-bottom: 0;
  `};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: ${({ twoColumns }) => twoColumns ? '13px' : '15px'};
    line-height: ${({ twoColumns }) => twoColumns ? '16px' : '20px'};
    margin-right: 24px;
    width: 100px;
    font-weight: 600;

    ${({ fullSize }) => fullSize && css`
      width: 250px;
      margin-right: 8px;
      margin-bottom: 0;
    `};
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    width: 88px;
    margin-right: 12px;

    ${({ fullSize }) => fullSize && css`
      width: 200px;
      margin-right: 8px;
      margin-bottom: 0;
    `};
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100%;
    margin: 0 0 12px 0;

    ${({ fullSize }) => fullSize && css`
      font-size: 13px;
      line-height: 16px;
    `};
  }
`;


export const CriteryWrapper = styled(FlexBox)<{ twoColumns?: boolean, fullSize?: boolean, position: VOTE_BLOCK_POSITION }>`

  flex-direction: ${({ twoColumns, fullSize }) => twoColumns && !fullSize ? 'column' : 'row'};
  min-height: ${({
    twoColumns,
    fullSize,
    position
  }) => [VOTE_BLOCK_POSITION.longread, VOTE_BLOCK_POSITION.bottom].includes(position) ? (twoColumns ? '62px' : '80px') : (twoColumns ? '82px' : '56px')};
  // margin-top: 24px;

  ${({ fullSize }) => fullSize && css`
    margin-top: 16px;

    &:not(:first-child) {
      margin-top: 0;
    }

    &:not(:last-child) {
      border-bottom: 1px solid ${Colors.galBlack21};
    }
  `};

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-top: ${({ twoColumns, fullSize }) => fullSize ? '0px' : '12px'};
    height: ${({ twoColumns, fullSize }) => fullSize ? '54px' : '24px'};
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    flex-direction: column;
    margin-top: ${({ twoColumns, fullSize }) => fullSize ? '0px' : '16px'};
    height: ${({ twoColumns, fullSize }) => fullSize ? '96px' : '60px'};

    &:not(:last-child) {
      margin-bottom: ${({ twoColumns, fullSize }) => fullSize ? '16px' : '0px'};
      border-bottom: none;
    }
  }
`

export const BlocksWrapper = styled(FlexBox)<{ iSBookMainPage?: boolean }>`
  width: 100%;
  flex-direction: column;
  row-gap: 24px;
  box-sizing: border-box;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    row-gap: 16px;
  }
  @media (max-width: ${LayoutConst.screen.md}px) {
    row-gap: 8px;
  }
  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    row-gap: 0px;
    width: ${({ iSBookMainPage }) => iSBookMainPage ? '100%' : 'calc(100% - 20px)'};
    margin: ${({ iSBookMainPage }) => iSBookMainPage ? '0 auto' : '0 10px'};
  }
`

export const MarkList = styled(GridBox)<{ twoColumns?: boolean, fullSize?: boolean, columnsGrid?: string, widthGrid?: string }>`
  grid-template-columns: ${({ columnsGrid, widthGrid }) => `repeat(${columnsGrid}, ${widthGrid}px)`};
  max-width: ${({ twoColumns, fullSize }) => twoColumns && !fullSize ? '455px' : fullSize ? 'none' : '247px'};
  width: 100%;
  justify-content: space-between;
  place-items: center;
    // ${({ fullSize }) => fullSize && css`
  //   place-items: center;
  `};

  @media (max-width: ${LayoutConst.screen.md}px) {
    max-width: none;
    grid-template-columns:  ${({ twoColumns }) => twoColumns ? 'repeat(10, 1fr);' : 'repeat(5, 1fr);'};
    gap: 12px;
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    max-width: ${({ fullSize }) => fullSize ? 'none' : '177px'};
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
      // width: ${({ fullSize }) => fullSize ? '268px' : '276px'};
      // grid-template-columns:  ${({ fullSize }) => fullSize ? 'repeat(5, 47.2px);' : 'repeat(5, 48.8px);'};
    grid-template-columns:  ${({ fullSize }) => fullSize ? 'repeat(5, 1fr);' : 'repeat(5, 1fr);'};
    gap: 8px;
    max-width: none;
  }
`

export const RectangleCount = styled.span<{ twoColumns?: boolean, fullSize?: boolean }>`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: ${({ twoColumns }) => twoColumns ? '15px' : '17px'};
  line-height: ${({ twoColumns }) => twoColumns ? '20px' : '22px'};
  color: #909090;
  top: 24px;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 13px;
    line-height: 16px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: ${({ fullSize }) => fullSize ? '13px' : '17px'}
    line-height: ${({ fullSize }) => fullSize ? '16px' : '22px'}
  }
`;